import { For, type Component } from "solid-js";
import Hero from "./Hero.jsx";
import Stat from "./Stats.jsx";
import Features from "./Features.jsx";

const Home: Component = () => {
  return (
    <>
      <Hero />
      {/* <Stat />
      <Features /> */}
    </>
  );
};

export default Home;
